import { ErrorMessages, IErrorMessage } from '../data/ErrorMessages';
import {
  ICheckCpfExistResponse,
  ICheckEmailExistResponse,
  ICheckPhoneExistResponse,
  ICheckSocialResponse
} from '../interfaces/QueryController';
import { IUser } from '../interfaces/user';
import { SentryContextsEnum } from '../utils/Sentry';
import { GET } from './api';

const ACCOUNT_SERVICE = process.env.REACT_APP_BASE_URL_ACCOUNT_SERVICE;

export async function checkEmailExist(
  email: string,
  errorMessage: IErrorMessage = ErrorMessages.EMAIL_EXIST_SIGN_UP
): Promise<ICheckEmailExistResponse> {
  const response = await GET(
    `${ACCOUNT_SERVICE}/api/v1/email/${email}`,
    errorMessage
  );
  return response.data;
}

export async function checkExistNumberPhone(
  number: string,
  context?: SentryContextsEnum
): Promise<ICheckPhoneExistResponse> {
  const customErrorMessage = ErrorMessages.PHONE_EXIST;
  if (context) customErrorMessage.context = context;

  const response = await GET(
    `${ACCOUNT_SERVICE}/api/v1/cell-phone/${number}`,
    ErrorMessages.PHONE_EXIST
  );
  return response.data;
}

export async function checkExistsCpf(
  cpf: string
): Promise<ICheckCpfExistResponse> {
  const response = await GET(
    `${ACCOUNT_SERVICE}/api/v1/${cpf}/cpf`,
    ErrorMessages.CHECK_CPF_EXIST
  );
  return response.data;
}

export async function getSocialsLoginByIdentifier(
  identifier: string,
  code: string,
  type: 'cellPhone' | 'email'
): Promise<ICheckSocialResponse> {
  const errorMessage =
    type === 'cellPhone'
      ? ErrorMessages.GET_ACCOUNT_INFO_FORGOT_ACCOUNT
      : ErrorMessages.GET_SOCIAL_CONNECTED_ACCOUNTS;

  const response = await GET(
    `${ACCOUNT_SERVICE}/api/v1/users/credentials?${type}=${identifier}&${type}Code=${code}`,
    errorMessage
  );

  return response.data;
}

export async function sessionUserInfo(): Promise<IUser> {
  const response = await GET(
    `${ACCOUNT_SERVICE}/api/v1/account`,
    ErrorMessages.GET_ACCOUNT_DATA
  );

  return response.data;
}
